import { SipProvidersManagementTab } from '../sip-trunk/SipProvidersManagement';

const SipTrunkVendorsPage = () => {
  return <SipProvidersManagementTab />;
};

export default SipTrunkVendorsPage;
